<template>
  <div class="relative">
    <BaseChip
      v-for="(item, idx) in parsedItems"
      :key="idx"
      :label="item"
      class="m-1"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import BaseChip from '@/components/BaseComponents/BaseChip.vue';
import { parseJsonStringArray } from '@/helpers/parseJsonStringArray';

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean, Array, Date, Object],
    default: null
  },
  readOnly: {
    type: Boolean,
    default: false
  },
  singleLine: {
    type: Boolean,
    default: false
  },
  autoSave: {
    type: Boolean,
    default: true
  },
  rowId: { type: [String, Number], default: '' },
  header: { type: Object, required: true },
  // US 3399: id deklareres, men videreformidles BEVISST ikke - denne komponenten rendrer ingen
  // labelable kontroll aa peke paa. Deklarasjonen finnes for aa STOPPE Vues attribute-fallthrough:
  // uten den ville en id havnet paa rot-diven, og en <label for=> dit ville tilfredsstilt statisk
  // analyse mens HTMLLabelElement.control fortsatt var null. Se editComponentAcceptsId.
  id: { type: String, default: undefined }
});

defineEmits(['update:modelValue']);

const parsedItems = computed(() => {
  if (!props.modelValue) {
    return [];
  }

  // WI 2224: string_agg-aggregat leverer en JSON-array-streng (`'["rød","blå"]'`) → chips.
  if (typeof props.modelValue === 'string') {
    return parseJsonStringArray(props.modelValue);
  }

  // Backend sender ColumnData objekt med Value som array
  if (props.modelValue && typeof props.modelValue === 'object' && 'value' in props.modelValue) {
    return Array.isArray(props.modelValue.value) ? props.modelValue.value : [];
  }

  // Fallback: hvis det fortsatt er en array direkte
  return Array.isArray(props.modelValue) ? props.modelValue : [];
});
</script>

